import React from 'react'
import AutosuggestDropdown from './AutosuggestDropdown'

const ReactAutoSuggestDropdown = (props) => {
    return(
      <div className="suggest-div">                 
          <input
              className='standard-input-field'
              placeholder={props.placeholder}
              value={props.searchValue}
              onFocus={props.showDropdown}
              onChange={props.updateSearchValue}
            />                 
          <AutosuggestDropdown
            itemsToDisplay={(props.list.length) ? props.list : null}
            displayDropdown={props.displayDropdownMenu}
            searchFor={props.searchValue}
            chooseDropdownItem={props.chooseDropdownItem}
            highlightColour={props.highlightColour}
          />
        </div>
    )
}

export default ReactAutoSuggestDropdown


// WEBPACK FOOTER //
// ./src/components/ui/AutoSuggestionDropdown/index.js